import cn from "@/lib/cn";
import React from "react";
import type { BentoHeaderProps } from "../../types";

const BentoHeader: React.FC<BentoHeaderProps> = ({
  title,
  subtitle,
  className = "",
}) => {
  return (
    <div className={cn("text-left", className)}>
      <h2 className="text-display1 text-neutral-base-override">{title}</h2>
      {subtitle ? (
        <p className="text-body2 text-neutral-base-override mt-4">{subtitle}</p>
      ) : null}
    </div>
  );
};

export default BentoHeader;
